import { SelectOptionProps } from '@acceso/design-system';

import { CHANNEL_MEDIA_TYPE_TO_ICON } from '@/features/broadcasters/constants/icons';
import { useGetPrograms } from '@/features/programs/api/get-programs';

export function useProgramOptions(channelId?: string): SelectOptionProps<string>[] {
  const { data: { data: programs = [] } = {} } = useGetPrograms();
  const options = programs
    .filter(program => !channelId || program.channel.id === channelId)
    .map(program => ({
      label: program.name,
      value: program.id,
      icon: CHANNEL_MEDIA_TYPE_TO_ICON[program.channel.media_type],
    }));

  return options;
}
